import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

import { CourseParticipant } from '../../../services/dozent.service';

/**
 * Modal wrapper around `<app-participant-detail>`. Opened from the
 * Teilnehmende table (name click, eye icon, pencil icon) so the
 * deepest learner view sits as a dialog overlay instead of replacing
 * the right-hand tabset inline.
 */
@Component({
  selector: 'app-participant-detail-dialog',
  templateUrl: './participant-detail-dialog.component.html',
  styleUrl: './participant-detail-dialog.component.scss',
})
export class ParticipantDetailDialogComponent {
  @Input() participant!: CourseParticipant;
  @Input() courses: any[] = [];
  @Input() currentCourseId: string | null = null;

  constructor(
    protected dialogRef: NbDialogRef<ParticipantDetailDialogComponent>,
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
